$(document).ready(function() {
    $(".js-open-feedback-form").colorbox();
    $(".ccs-item").matchHeight();

	var nav = $('.nav'),
		toggleBtn = $('.toggle-nav');

	toggleBtn.click(function() {
	  nav.fadeToggle().toggleClass('open');;
	  $(this).toggleClass('open');;
	});

	nav.find('a').click(function(e){
		closeNav();
	});

	function closeNav() {
		toggleBtn.removeClass('open');
		nav.slideUp().removeClass('open');
	};


	var header = $('.header'),
		headerHeight = header.height();

	var checkScroll = function (){
		var scrTop = $(this).scrollTop();
		if( scrTop <= headerHeight && header.hasClass("fixed")) {
			header.removeClass("fixed appear");
			header.addClass("disappear");
			$('body').css('padding', 0);
		};

		if ( scrTop > headerHeight && !header.hasClass("fixed") ){
			header.removeClass("disappear");
			header.addClass("fixed appear");
			$('body').css('padding-top', headerHeight);
		};
	};

	checkScroll();

	$(window).scroll(function(){
		checkScroll();
	});

	$('.main-slider-container').slick({
		dots: true,
		arrows: false,
		draggable: true,
		autoplay: true,
  		autoplaySpeed: 6000
	});

	$('.section-videos-items-carousel').slick({
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 3,
		prevArrow: '<button type="button" class="slick-prev">Previous<span><span></span></span></button>',
		nextArrow: '<button type="button" class="slick-next">Next<span><span></span></span></button>',
		responsive: [
			{
				breakpoint: 1000,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				},
			},{
				breakpoint: 768,
				settings: {
					variableWidth: true,
					slidesToScroll: 1,
				},
			},
		],
	});



	$(".fancybox, .zoom_picture, .gallery-item, .video-link").fancybox({});

	$(".video-link a").fancybox({
        'padding'		: 0,
        'autoScale'		: false,
        'transitionIn'	: 'none',
        'transitionOut'	: 'none',
        'title'			: this.title,
        'width'			: 680,
        'height'		: 495,
        'href'			: this.href,
        'type'			: 'swf',
        'swf'			: {
            'wmode'		: 'transparent',
            'allowfullscreen'	: 'true'
        }
	});

	$('body').on('click', '.videogallery .video a.img:not(.playing)', function(e){
		e.preventDefault();
		var vidId = $(this).data('src'),
			vidHoster = $(this).data('hoster'),
			group = $(this).closest('.videogallery'),
			container = $(this),
			html;

			switch(vidHoster) {
		    	case 'rutube':
		        	html = '<iframe width="' + container.width() + '" height="' + container.height() + '" src="//rutube.ru/play/embed/' + vidId + '?autoStart=true" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowfullscreen></iframe>'
		        	break;
		    	default:
		        	html = '<iframe width="' + container.width() +
						'" height="' + container.height() +
						'" src="//www.youtube.com/embed/' + vidId +
						'?autoplay=1&rel=0"  frameborder="0" allowfullscreen></iframe>'
			};

		group.find('.playing').removeClass('playing').empty();
		container.append( html );
		$(this).addClass('playing');
	});

	$('.scrollTo').click(function(e){
		e.preventDefault();
		var target = $(this).attr('href');
		$('html, body').animate({scrollTop: $(target).offset().top}, 300);
		return false;
	});

	$('.content table').wrap('<div class="table-wrap"></div>');


	 $('.ce-slider-main').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		fade: true,
		asNavFor: '.ce-slider-nav'
	});
	$('.ce-slider-nav').slick({
		variableWidth: true,
		slidesToScroll: 1,
		asNavFor: '.ce-slider-main',
		arrows: false,
		dots: false,
		centerMode: true,
		focusOnSelect: true
	});

	$('.tabs').each(function(){
		var container = $(this),
			btns = container.find('.tab-head'),
			content = container.find('.tabs-content'),
			contents = content.find('.tab');

		contents.not('.open').hide();

		btns.on('click',function(e){
			e.preventDefault();
			if( !$(this).hasClass('open') ){
				var i = $(this).index();
				btns.removeClass('open');
				$(this).addClass('open');

				content.find('.tab.open').removeClass('open').fadeOut(function() {
					contents.eq(i).fadeIn().addClass('open');
				});
			}
		});
	});

	$('.slider').each(function(){
		var container = $(this),
			btn = container.find('>.slider-btn'),
			content = container.find('>.slider-content'),
			animateTime = 200,
			smallHeight = 0;

		if(!content.hasClass('open')){
			content.stop().animate({ height: smallHeight }, parseInt(animateTime));
		};

		btn.click(function(e){
			e.preventDefault();
			btn.toggleClass('open');
			content.toggleClass('open');

			if(content.height() === smallHeight){
			  autoHeightAnimate(content, animateTime);
			} else {
			  content.stop().animate({ height: smallHeight }, animateTime);
			}
		});

		function autoHeightAnimate(element, time){
			var curHeight = element.height(),
			autoHeight = element.css('height', 'auto').height();

			element.height(curHeight);
			element.stop().animate({ height: autoHeight }, parseInt(time), function(){
				$(this).css('height', 'auto');
			});
		};
	});

});